
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import { useCreditTicketAdd } from '@/modules/credit/ticket/model/add';
import { ROUTE_NAME_CREDIT } from '@/modules/credit/ticket/router';

export default defineComponent({
    name: ROUTE_NAME_CREDIT.TICKET.ADD,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, create } = useCreditTicketAdd();

        return { v$, model, create };
    }
});
